import { IntlShape } from 'react-intl';
import { action, observable } from 'mobx';
import { IArtifactDTO, IMeetingArtifactDTO } from '../../../../../api/artifacts.dao';

class PublishArtifactPopoverVM {
    @observable
    public meetingArtifact: IMeetingArtifactDTO = null;
    @observable
    public artifact: IArtifactDTO = null;

    constructor(
        public readonly intl: IntlShape,
        public readonly onPublishPassportReplay: (assetMetadataId: number, meetingId: number) => void,
    ) {

    }

    @action
    public setMeetingArtifact = (meetingArtifact: IMeetingArtifactDTO, assetMetadataId: number): void => {
        this.meetingArtifact = meetingArtifact;
        this.artifact = meetingArtifact.artifacts.find(a => a.assetMetadataId === assetMetadataId);
    };

    public get isPopoverOpened(): boolean {
        return !!this.meetingArtifact && !!this.artifact;
    };

    @action
    public closePopover = (): void => {
        this.artifact = null;
        this.meetingArtifact = null;
    };

    public onPublishPassportReplayHandler = (meetingId: number, assetMetadataId: number): void => {
        this.onPublishPassportReplay(assetMetadataId, meetingId);
        this.closePopover();
    };

};

export default PublishArtifactPopoverVM;
